import { VaporThemeSwitcher } from "./VaporThemeSwitcher";

export const vaporTheme = () => [
  {
    priority: 100,
    target: "$ONE_TOOLBAR_CONTENT_RIGHT",
    handler: { component: VaporThemeSwitcher }
  }
];
